import { observer } from 'mobx-react-lite';

import Button from '@/components/goalbased/Questionarie/Button/Button';
import type { QuizExerciseSectionRecordModelType } from '@/models/api';
import { useStore } from '@/models/root-store';

type Props = {
  activeLevelSection: QuizExerciseSectionRecordModelType;
};

const ActivityLevels: React.FC<Props> = observer(({ activeLevelSection }) => {
  const { cartStore } = useStore();
  const { goalBased } = cartStore;

  return (
    <div className="my-14 px-4 md:p-0">
      <div className="mb-8 font-interBold text-4xl leading-9 text-black md:mb-6">
        {activeLevelSection.questionText}
      </div>
      <div className="">
        {activeLevelSection &&
          activeLevelSection.quizAnswers &&
          activeLevelSection.quizAnswers.map((answer) => {
            const activeButton = goalBased.exercise === answer.value;
            return (
              <div key={answer.id} className="mb-6">
                <Button
                  theme={activeButton ? 'secondary' : 'primary'}
                  className="w-full justify-center px-3 py-5 font-interBold leading-4 last:mb-0 last:mr-0 lg:mb-0 lg:mr-4 lg:py-4 lg:leading-6"
                  onClick={() => {
                    goalBased.setPreset('exercise', answer.value);
                    if (answer.calorie)
                      goalBased.setPreset(
                        'fixedCalories',
                        Number(answer.calorie),
                      );
                    if (answer.bucket)
                      goalBased.setPreset('bucket', answer.bucket);
                  }}
                >
                  {answer.name}
                </Button>

                {activeButton && answer.subText && (
                  <div className="ml-4 mt-2 border-l border-grey-dark pl-2 font-interMedium text-sm text-grey-dark">
                    {answer.subText}
                  </div>
                )}
              </div>
            );
          })}
      </div>
    </div>
  );
});

export default ActivityLevels;
